import { Link } from "@reach/router"
import styled from "styled-components"
import { Text } from "./"
import historyLength from "../utilities/historyLength"

export default styled(Text.withComponent(Link)).attrs(
  ({ color, isCurrent, back }) => ({
    color: isCurrent ? "black" : color || "link",
    onClick: back
      ? e => {
          if (historyLength() > 0) {
            console.log("history back")
            e.preventDefault()
            window.history.back()
          }
        }
      : null
  })
)`
  text-decoration: none;
  transition: color 180ms ease;
  ${({ invert }) => invert && `color: black`};
  &:hover {
    color: ${({ theme: { colors } }) => colors.linkHover};
    ${({ invert, theme: { colors } }) => invert && `color: ${colors.link}`};
    text-decoration: none;
  }
`
